import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { workspaceByIdSelector } from '@futrli/shared-services';
import { useIntegrationsView } from '@futrli/views/hooks/useIntegrationsView';
import { WorkspacesListingItem } from '@futrli-sdk/workspaces';

import { StoreState } from '../core/types';

export const useCurrentOrganisation = () => {
  const { organisationId, workspaceId } = useParams();

  const organisation = useSelector((state: StoreState) => {
    if (!organisationId || !workspaceId) {
      return null;
    }
    const { normalised } = state;

    const currentWorkspace = workspaceByIdSelector(normalised, workspaceId) as WorkspacesListingItem;
    const storedOrganisation = currentWorkspace
      ? currentWorkspace.organisations.find(o => o.id === organisationId)
      : null;

    return storedOrganisation;
  });

  return organisation;
};

export const useIntegrations = () => {
  return useIntegrationsView(false).integrations ?? null;
};

export const useCurrentOrgIntegrationSlug = () => {
  const organisation = useCurrentOrganisation();

  const integrations = useIntegrations();

  const ds = organisation?.datasource;
  return integrations?.find(i => i.id === ds?.integration_id)?.slug;
};

export const useIsEditableCOA = () => {
  const currentIntegrationSlug = useCurrentOrgIntegrationSlug();
  return currentIntegrationSlug === 'sage50' ? false : true;
};
